import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import FloatingWorkflowStatus from '../features/pricing/components/FloatingWorkflowStatus';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:text-blue-700 focus:p-3"
      >
        Skip to content
      </a>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="md:pl-60">
        <Header title="SmartRate" onMenuClick={() => setSidebarOpen(true)} />
        <main
          id="main-content"
          tabIndex={-1}
          className="p-4 sm:p-6 lg:p-8 pb-28"
        >
          <div
            className={
              pathname === '/calendar' ? 'w-full min-w-0' : 'mx-auto max-w-7xl'
            }
          >
            {children}
          </div>
        </main>
      </div>
      <FloatingWorkflowStatus />
    </div>
  );
};
export default Layout;
